import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'

export const shopsService = new CachedService(CachedService.entities.Orderadmin_Products_Entity_Shop, '/products/shops', HALApiService, createItemsData)
